import { EntityState } from './entity-state';
import type { EntitySearchArg } from './paged-types';
import { SEARCH_RESULT_LIMIT } from './paged-types';
import { buildPagedQueryString, buildSearchWhere } from './query-params';

export type AddonSearchItem = {
    id: string;
    name: string;
    type: string;
    productLevel: string;
    salesforceQuoteNumber: string;
    notes: string;
    state: string;
    subscriptionId: string;
};

type AddonApiItem = {
    id?: string;
    name?: string | null;
    type?: string | null;
    productLevel?: string | null;
    salesforceQuoteNumber?: string | null;
    notes?: string | null;
    state?: string | null;
    subscriptionId?: string | null;
};

type AddonsApiResponse = {
    addons?: AddonApiItem[];
};

type AddonApiItemWithId = AddonApiItem & { id: string };

const hasId = (a: AddonApiItem): a is AddonApiItemWithId => typeof a.id === 'string';

const transformAddon = (a: AddonApiItemWithId): AddonSearchItem => ({
    id: a.id,
    name: a.name ?? '',
    type: a.type ?? '',
    productLevel: a.productLevel ?? '',
    salesforceQuoteNumber: a.salesforceQuoteNumber ?? '',
    notes: a.notes ?? '',
    state: a.state ?? EntityState.ACTIVE,
    subscriptionId: a.subscriptionId ?? '',
});

const ADDON_SEARCH_COLUMNS = [
    'name',
    'salesforceQuoteNumber',
    'type',
    'productLevel',
    'notes',
] as const;
const ADDON_UUID_COLUMNS = ['id'] as const;

export const searchAddonsQuery = {
    query: ({ term, limit = SEARCH_RESULT_LIMIT + 1, where }: EntitySearchArg) => ({
        url: `/mp/1/addons?${buildPagedQueryString({
            offset: 0,
            limit,
            order: [['name', 'ASC']],
            where: {
                ...buildSearchWhere(ADDON_SEARCH_COLUMNS, term, ADDON_UUID_COLUMNS),
                ...where,
            },
        })}`,
        method: 'get',
    }),
    transformResponse: (response: AddonsApiResponse): AddonSearchItem[] =>
        (response?.addons ?? []).filter(hasId).map(transformAddon),
};
